import { render, staticRenderFns } from "./3-enter-details.vue?vue&type=template&id=9febb06a&scoped=true"
import script from "./3-enter-details.vue?vue&type=script&lang=js"
export * from "./3-enter-details.vue?vue&type=script&lang=js"
import style0 from "./3-enter-details.vue?vue&type=style&index=0&id=9febb06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9febb06a",
  null
  
)

export default component.exports